import axiosAuthoringInstance, { BACKEND_URL } from './constants';

export const getRegulatories = (languageCode, countryCode) => {
  const newParams = new URLSearchParams();
  if (languageCode) newParams.append('language_code', languageCode);
  if (countryCode) newParams.append('country_code', countryCode);
  return axiosAuthoringInstance
    .get('/sdsAuthoring/utils/regulations/', { params: newParams })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const getPDFFile = (sdsId, logoPosition) => {
  return axiosAuthoringInstance
    .get(`/sdsAuthoring/files/${sdsId}/pdf/`, {
      params: {
        logo_position: logoPosition,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const getPPEItems = (categories, languageCode) => {
  const newParams = new URLSearchParams();
  categories?.map(el => newParams.append('category', el));
  newParams.append('language', languageCode);
  return axiosAuthoringInstance
    .get('sdsAuthoring/utils/ppe/', { params: newParams })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const getAllPdfs = params => {
  return axiosAuthoringInstance
    .get('/pdfs/', { params: params })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const getCreatedPDFs = (page, pageSize, filters) => {
  const newParams = new URLSearchParams();
  if (filters?.status && filters.status.length > 0)
    filters.status.map(el => newParams.append('status', el));
  if (filters.isImported) newParams.append('is_imported', filters.isImported);

  newParams.append('page', page);
  newParams.append('page_size', pageSize);

  return axiosAuthoringInstance
    .get('sdsAuthoring/files/', { params: newParams })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const getCreatedComponents = (page, pageSize, statuses) => {
  const newParams = new URLSearchParams();
  newParams.append('page', page);
  newParams.append('page_size', pageSize);
  statuses?.map(el => newParams.append('status', el));

  return axiosAuthoringInstance
    .get('sdsAuthoring/customerComponents/', { params: newParams })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const getUserAvatar = url => {
  if (url.includes(BACKEND_URL)) return url;
  return BACKEND_URL + url;
};

export const getExtractionStatus = params => {
  return axiosAuthoringInstance
    .get(`sdsAuthoring/utils/getExtractionStatus/`, { params: params })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const getTranslations = lang => {
  return axiosAuthoringInstance
    .get(`/sdsAuthoring/utils/translations/`, {
      params: { language_code: lang },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const getPhyChemProperties = (lang, sds_id) => {
  return axiosAuthoringInstance
    .get('/sdsAuthoring/utils/physChemProperties/', {
      params: {
        language_code: lang,
        created_sds_id: sds_id,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const getDefaultCountriesSettings = lang => {
  return axiosAuthoringInstance
    .get('/sdsAuthoring/utils/defaultCountriesSettings/', {
      params: {
        language_code: lang,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const getCreatedSdsFiles = id => {
  return axiosAuthoringInstance
    .get(`sdsAuthoring/files/${id}/`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const getIsoIcons = type => {
  return axiosAuthoringInstance
    .get(`sdsAuthoring/utils/isoIcons/`, { params: { type: type } })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const getClassification = (lang, country) => {
  return axiosAuthoringInstance
    .get(`sdsAuthoring/utils/classifications/`, {
      params: {
        language_code: lang,
        country_code: country,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const getGhsStatements = (lang, country) => {
  return axiosAuthoringInstance
    .get(`sdsAuthoring/utils/ghsStatements/`, {
      params: {
        language_code: lang,
        country: country,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const getPrecautionStatements = lang => {
  return axiosAuthoringInstance
    .get(`sdsAuthoring/utils/pCodesStatements/`, {
      params: { language_code: lang },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const getCustomerComponents = (page, pageSize) => {
  const newParams = new URLSearchParams();
  newParams.append('page', page);
  newParams.append('page_size', pageSize);
  return axiosAuthoringInstance
    .get('sdsAuthoring/customerComponents/', { params: newParams })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const getSdsComponents = params => {
  return axiosAuthoringInstance
    .get('sdsAuthoring/utils/components/', { params: params })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const getKeywordComponent = params => {
  return axiosAuthoringInstance
    .get('casRegister/', { params: params })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const impersonateUser = email => {
  return axiosAuthoringInstance
    .get(`/user/impersonate/?impersonated_email=${encodeURIComponent(email)}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
  }

export const getSupplierListing = () => {
  return axiosAuthoringInstance
    .get('sdsAuthoring/supplierInfo/')
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const generateUfi = params => {
  return axiosAuthoringInstance
    .get('sdsAuthoring/utils/generateUFI/', { params: params })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export const getManufacturerListing = () => {
  return axiosAuthoringInstance
    .get('sdsAuthoring/manufacturerInfo/')
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

export const generateFormulationNumber = () => {
  return axiosAuthoringInstance
    .get('sdsAuthoring/utils/generateFormulationNumber/')
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

